/**
 * Interop between "export default" and "module.exports".
 */ export function interopDefault(mod) {
    return mod.default || mod;
}

//# sourceMappingURL=interop-default.js.map